import React from 'react';
import { defaultIconProps } from './common';
const CircleMinus = ({ primaryColor, width, height }) => (React.createElement("svg", { width: width, height: height, viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { x: 3, y: 3, width: 28, height: 28, rx: 14, fill: primaryColor }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.832 18.246A1.24 1.24 0 018.598 17a1.24 1.24 0 011.234-1.245l14.333-.013a1.24 1.24 0 011.233 1.246 1.24 1.24 0 01-1.233 1.245l-14.333.013z", fill: "#fff" })));
CircleMinus.defaultProps = defaultIconProps;
export default CircleMinus;
